import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie"; // Import js-cookie

export const useLogout = () => {
  const navigate = useNavigate();

  const logout = () => {
    console.log("Logging out user...");

    // Remove authentication-related data from cookies
    Cookies.remove("authToken"); // Remove authentication token
    Cookies.remove("userData"); // Remove user data

    // Redirect to login page
    navigate("/login");
  };

  return logout;
};
